import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/972544822788"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 group"
      data-testid="whatsapp-float-btn"
      aria-label="צור קשר בוואטסאפ"
    >
      <MessageCircle className="w-7 h-7 md:w-8 md:h-8 text-white" />
      <span
        className="absolute -top-7 left-1/2 -translate-x-1/2 bg-white/95 dark:bg-slate-800 text-green-600 dark:text-green-400 text-[11px] font-black px-2.5 py-0.5 rounded-full shadow-md border border-green-200 dark:border-green-900 whitespace-nowrap pointer-events-none"
        data-testid="whatsapp-float-label"
      >
        ווצאפ
      </span>
      <div className="absolute right-full mr-3 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        דברו איתנו בוואטסאפ
      </div>
    </a>
  );
};

export default WhatsAppButton;
